// extracted by mini-css-extract-plugin
module.exports = {"main_color":"#009ccc","container":"privacy_policy-module--container--3_OmD"};